import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, MapPin } from 'lucide-react';
const purchases = [{
  name: 'Fernando G.',
  location: 'La Plata, Buenos Aires',
  time: 'Hace 12 min',
  product: 'Combo Completo + Pack Pro'
}, {
  name: 'Alejandro M.',
  location: 'Salta Capital',
  time: 'Hace 27 min',
  product: 'Super Combo Pro'
}, {
  name: 'Diego R.',
  location: 'Mar del Plata, Buenos Aires',
  time: 'Hace 43 min',
  product: 'Combo Completo + Pack Pro'
}, {
  name: 'Pablo S.',
  location: 'Neuquén Capital',
  time: 'Hace 1 hora',
  product: 'Super Combo Pro'
}, {
  name: 'Martín L.',
  location: 'Resistencia, Chaco',
  time: 'Hace 1 hora',
  product: 'Combo Completo + Pack Pro'
}, {
  name: 'Gustavo T.',
  location: 'San Juan Capital',
  time: 'Hace 2 horas',
  product: 'Super Combo Pro'
}];
export function RecentPurchases() {
  const [visibleIndex, setVisibleIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setVisibleIndex(prev => (prev + 1) % purchases.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <>
      <section className="py-8 bg-gray-50 border-y border-gray-200" data-id="element-269">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-270">
          <div className="text-center mb-6" data-id="element-271">
            <h3 className="text-xl md:text-2xl font-black text-matte mb-1" data-id="element-272">
              🔥 Compras recientes
            </h3>
            <p className="text-gray-500 text-sm font-medium" data-id="element-273">
              Carpinteros de todo el país ya están fabricando con el sistema
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-274">
            {purchases.map((purchase, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08
          }} className="bg-white border border-gray-200 p-3 flex items-start gap-3 shadow-sm" data-id="element-275">
                <div className="bg-green-100 p-1.5 flex-shrink-0" data-id="element-276">
                  <ShoppingBag className="w-4 h-4 text-green-600" data-id="element-277" />
                </div>
                <div className="min-w-0" data-id="element-278">
                  <p className="font-bold text-matte text-xs truncate" data-id="element-279">
                    {purchase.name}
                  </p>
                  <p className="text-xs text-gray-500 flex items-center mt-0.5" data-id="element-280">
                    <MapPin className="w-3 h-3 mr-0.5 flex-shrink-0" data-id="element-281" />{' '}
                    {purchase.location}
                  </p>
                  <p className="text-xs text-green-600 font-medium mt-0.5" data-id="element-282">
                    {purchase.time}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Floating notification */}
      <div className="fixed bottom-4 left-4 z-50 max-w-xs" data-id="element-283">
        <AnimatePresence mode="wait" data-id="element-284">
          <motion.div key={visibleIndex} initial={{
          opacity: 0,
          y: 20,
          scale: 0.9
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: -10,
          scale: 0.9
        }} transition={{
          duration: 0.4
        }} className="bg-white border border-gray-200 shadow-xl p-3 flex items-start gap-3" data-id="element-285">
            <div className="bg-green-100 p-1.5 flex-shrink-0" data-id="element-286">
              <ShoppingBag className="w-4 h-4 text-green-600" data-id="element-287" />
            </div>
            <div data-id="element-288">
              <p className="font-bold text-matte text-sm" data-id="element-289">
                {purchases[visibleIndex].name}
              </p>
              <p className="text-xs text-gray-500" data-id="element-290">
                {purchases[visibleIndex].location}
              </p>
              <p className="text-xs text-green-600 font-semibold mt-0.5" data-id="element-291">
                Compró {purchases[visibleIndex].product} ·{' '}
                {purchases[visibleIndex].time}
              </p>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </>;
}